export interface Line {
  id: number;
  name: string;
}

export interface Category {
  id: number;
  name: string;
  description: string;
  color: string;
  status: boolean;
  priority: number;
  createdAt: Date;
  deletedAt?: any;
  updatedAt: Date;
}
export type Vendor = {
  id: number;
  name: string;
};
export type OrderDetail = {
  id: string;
  orderId: string;
  quantity: number;
  priceUnit: number;
  priceCost: number;
  totalProduct: number;
  discount: number;
  quantity_discount: number;
  priceUnit_discount: number;
  total_price_discount: number;
  description: string;
  status: string;
  createdAt: Date;
  deletedAt: string;
  updatedAt: Date;
  product: any;
};
export type Order = {
  id: string;
  vendor: any;
  subtotal: number;
  total: number;
  status: string;
  isTip: boolean;
  discount: number;
  table: null;
  tableCustom: null;
  items: number;
  ordersDetails?: OrderDetail[];
  createdAt: Date;
  deletedAt: null;
  updatedAt: Date;
};

export type OrdersDetail = {
  id: string;
  orderId: string;
  quantity: number;
  priceUnit: number;
  priceCost: number;
  totalProduct: number;
  totalProductExcludingTaxes: number;
  priceUnitDiscountExcludingTaxes: number;
  isPromotion: boolean;
  discount: number;
  quantity_discount: number;
  priceUnit_discount: number;
  discount_value: number;
  total_price_discount: number;
  total: number;
  description: string;
  status: string;
  createdAt: Date;
  deletedAt?: Date | null;
  updatedAt: Date;
  product: {
    id: number;
    name: string;
    description: string;
    ulrQR?: any; // if you're not sure about this field, use 'any' as its type
    status: boolean;
    isBowl: boolean;
    isPremium: boolean;
    event: boolean;
    fixCost?: any; // if you're not sure about this field, use 'any' as its type
    percentage: number;
    sellLetter: number;
    productIngredientPrice: number;
    product: any;
    isBuy: boolean;
    isLetter: boolean;
    supplyPrice: number;
    cookingPrice: number;
    otherPrice: number;
    sellPrice: number;
    subtotal: number;
    image?: any; // if you're not sure about this field, use 'any' as its type
    createdAt: Date;
    deletedAt?: any; // if you're not sure about this field, use 'any' as its type
    updatedAt: Date;
    lines: Array<{
      id: number;
      name: string;
      image: string;
      description: string;
      status: boolean;
      createdAt: Date;
      deletedAt?: any; // if you're not sure about this field, use 'any' as its type
      updatedAt: Date;
    }>;
    priceIndicatorsProduct: Array<{
      id: number;
      productsId: number;
      indicadorsId: number;
      value: number;
      createdAt: Date;
      deletedAt?: any; // if you're not sure about this field, use 'any' as its type
      updatedAt: Date;
      indicadors: {
        id: number;
        name: string;
        porcentage: number;
        status: boolean;
        priority: number;
        isOrder: boolean;
        isTips: boolean;
        isProduct: boolean;
        isFactureBase: boolean;
        createdAt: Date;
        deletedAt?: any; // if you're not sure about this field, use 'any' as its type
        updatedAt: Date;
      };
    }>;
    recipe: {
      id: number;
      name: string;
      state: boolean;
      createdAt: Date;
      deletedAt?: any; // if you're not sure about this field, use 'any' as its type
      updatedAt: Date;
      ingredientsRecipes: Array<{
        id: number;
        ingredientId: number;
        description?: any; // if you're not sure about this field, use 'any' as its type
        amount: number;
        measure?: any; // if you're not sure about this field, use 'any' as its type
        state: boolean;
        createdAt: Date;
        deletedAt?: any; // if you're not sure about this field, use 'any' as its type
        updatedAt: Date;
      }>;
    };
  };
  pricesIndicators: Array<{
    id: number;
    orderDetailId: string;
    indicadorId: number;
    value: number;
    createdAt: Date;
    deletedAt?: any; // if you're not sure about this field, use 'any' as its type
    updatedAt: Date;
    indicador: {
      id: number;
      name: string;
      porcentage: number;
      status: boolean;
      priority: number;
      isOrder: boolean;
      isTips: boolean;
      isProduct: boolean;
      isFactureBase: boolean;
      createdAt: Date;
      deletedAt?: any; // if you're not sure about this field, use 'any' as its type
      updatedAt: Date;
    };
  }>;
};

export enum OrderDetailStatus {
  created = 'created',
  cooking = 'cooking',
  done = 'done',
  // error = 'error',
}
